<template>
  <div class="container">
    <header>
      <div class="logo">
        <img style="width: 120px" src="../assets/images/LOGO.png" />
      </div>
      <!-- <div class="float" v-if="leftFloat">
        <img class="fl_img" src="../assets/images/float/float2.png" />
        <div class="fl_close" @click="closeFloat(1)"></div>
      </div>

      <div class="float2" v-if="rightFloat">
        <img class="fl_img2" style="width: 200px;" src="../assets/images/float/float1.png" />
        <div class="fl_close2" @click="closeFloat(2)"></div>
      </div> -->

      <nav class="nav1">
        <div class="menuList">
          <el-menu
            :router="true"
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-submenu
              :index="item.id"
              v-for="(item, index) in menuList"
              :key="item.menuName"
            >
              <template slot="title">{{ item.menuName }}</template>
              <el-menu-item
                v-for="(item2, index2) in item.childList"
                :index="`/detail/${item.menuName}/${item2.menuName}`"
                @click="toMenu(item.menuName, item2.menuName, index)"
                :route="{
                  name: 'detail',
                  query: {
                    title: `${item.menuName}`,
                    name: `${item2.menuName}`,
                    code: `${item2.apiAddr}`
                  }
                }"
                :key="item2.menuName"
              >
                <span>{{ item2.menuName }}</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>

        <img class="fgx" src="../assets/images/topfg.png" alt="" />
        <a
          href="https://once.xmu.edu.cn/search.jsp?wbtreeid=1150"
          target="_blank"
          ><i class="fa fa-search"></i
        ></a>
        <span v-if="userObj.realname">
          <!-- <a @click="signOut" class="sign_style">sign out</a> -->
        </span>
        <!-- <a
          v-else
          href=" https://m.kingboya.com/ysdh5/XmWebsite/manage/#/user/login"
          class="sign_style"
          >sign in</a
        > -->
        <!-- <a class="ch_style" @click="signOut"> 中文</a> -->
      </nav>
      <!-- <div class="burger">
        <div class="burger-line1">1111</div>in-width: 750p
        <div class="burger-line2"></div>
        <div class="burger-line3"></div>
      </div> -->
    </header>
    <!-- 轮播 -->
    <el-carousel
      id="home"
      class="carousel"
      ref="carousel"
      :interval="30000"
      @change="carouselChange(activeIndex)"
      style="
        box-shadow: 0px 2px 20px 0px rgba(36, 36, 36, 0.2);
        padding-top: 65px;
      "
    >
      <el-carousel-item class="carousel_slide" v-for="v in imgList" :key="v.id">
        <!-- <img src="../assets/images/banner/banner0.png" /> -->
        <img :src="`${filePreview}${v.photo}`" @click="routetolink(v)" />
      </el-carousel-item>
      <!--    <el-carousel-item class="carousel_slide">
        <img src="../assets/images/banner/banner1.png" />
      </el-carousel-item>
      <el-carousel-item class="carousel_slide">
        <img src="../assets/images/banner/banner2.png" />
      </el-carousel-item>
      <el-carousel-item class="carousel_slide">
        <img src="../assets/images/banner/banner3.png" />
      </el-carousel-item>
      <el-carousel-item class="carousel_slide">
        <img src="../assets/images/banner/banner4.png" />
       muted有声 loop循环
       <video src="../assets/videos/v4.mp4" muted autoplay loop></video> 
      </el-carousel-item>-->
    </el-carousel>
    <div class="content-wrapper">
      <about-us></about-us>
      <!-- <news></news> -->
      <div class="act_bg">
        <activities></activities>
      </div>
      <publication></publication>
      <teams></teams>
      <!-- <section class="data-section">
        <div class="data-piece" v-for="(item, index) in datas" :key="index">
          <i :class="item.icon"></i>
          <div class="num">{{ item.num }}</div>
          <div class="data-desc">{{ item.desc }}</div>
        </div>
      </section> -->
      <info-count></info-count>
      <!-- <cooperative-unit></cooperative-unit> -->
      <!-- <gallery></gallery> -->
    </div>
    <el-backtop :right="15">
      <i class="el-icon-caret-top"></i>
    </el-backtop>
    <footer>
      <div class="footer-menus">
        <el-container style="padding: 0">
          <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :md="8">
              <div class="contact-us">
                <p class="menu-title">
                  Contact
                  <img class="fenge" src="../assets/images/fenge.png" />
                </p>

                <ul class="address-list">
                  <li class="pt-0">
                    <span class="d-inline-block display-30 display-sm-29"
                      ><img src="../assets/images/dingwei.png"
                    /></span>
                    <span
                      class="d-inline-block w-85 display-30 display-sm-29 vertical-align-top pl-2"
                      >Room A3-311 Zhou Long Quan Building, No. 4221 Xiang'an
                      South Road, Xiamen, Fujian, China 361102</span
                    >
                  </li>
                  <li>
                    <span class="d-inline-block display-30 display-sm-29"
                      ><img src="../assets/images/dianhua.png"
                    /></span>
                    <span
                      class="d-inline-block w-85 display-30 display-sm-29 vertical-align-top pl-2"
                      >86-592-2880805</span
                    >
                  </li>
                  <li class="pb-0">
                    <span class="d-inline-block display-30 display-sm-29"
                      ><img src="../assets/images/youxiang.png"
                    /></span>
                    <span
                      class="d-inline-block w-85 display-30 display-sm-29 vertical-align-top pl-2"
                      >globalonce@xmu.edu.cn</span
                    >
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <links></links>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8">
              <quick-links></quick-links>
            </el-col>
          </el-row>
        </el-container>
      </div>
      <div class="link-box">
        <!-- <div class="link-btn">
          <a href="javascript:void(0)" onclick="_MEIQIA('showPanel')"><img src="../assets/images/kefu.png" /></a>
          <a v-if="userObj.realname" href="javascript:void(0)" @click="centerDialogVisible = true"><img
              src="../assets/images/liuyan.png" /></a>
          <a v-else href="https://m.kingboya.com/ysdh5/XmWebsite/manage/#/user/login"><img
              src="../assets/images/liuyan.png" /></a>
          <el-popover placement="left-start" trigger="hover" content="Tel：86-592-2880156">
            <img slot="reference" src="../assets/images/phone.png" />
          </el-popover>
        </div> -->
      </div>
      <!-- <div class="scroll-to-top">
        <a href="#home"><i class="fa fa-chevron-up"></i></a>
      </div> -->
      <section class="copyright">
        <div>
          © 2022 Ocean Negative Carbon Emissions (ONCE) All rights reserved.
        </div>
      </section>
    </footer>
    <el-dialog
      title="Message Board"
      :visible.sync="centerDialogVisible"
      width="40%"
      center
      :modal="false"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="Title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="Content">
          <el-input
            :rows="8"
            v-model="form.adviseContent"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="modalbottom">
        <a
          href="https://m.kingboya.com/ysdh5/XmWebsite/manage/#/online/cgformList/2c907f737e71f8d7017e71f8d7720000"
          class="spanstyle"
          target="_blank"
          >Check the history post</a
        >
        <el-button type="primary" @click="sendLY()">send</el-button>
      </div>
    </el-dialog>

    <img src="../assets/images/leftF.png" class="leftF" />
    <img src="../assets/images/rightF.png" class="rightF" />
    <!-- <img src="../assets/images/yuan.png" class="yuan" /> -->
  </div>
</template>

<script>
import anime from 'animejs/lib/anime.es';
import Isotope from '../assets/lib/isotope/isotope.pkgd.min';
import SmoothScroll from '../assets/lib/smooth-scroll/smooth-scroll.polyfills.min';
import AboutUs from '../components/index/AboutUs';
import News from '../components/index/News';
import Activities from '../components/index/Activities';
import Publication from '../components/index/Publication';
import Organization from '../components/index/Organization';
import Teams from '../components/index/Teams';
import InfoCount from '../components/index/InfoCount';
import Links from '../components/index/Links';
import QuickLinks from '../components/index/QuickLinks';
import CooperativeUnit from '../components/index/CooperativeUnit';
import Gallery from '../components/index/Gallery';
//    import ComFooter from '../components/ComFooter'

import { header } from './Home/index';

// (function(m, ei, q, i, a, j, s) {
//   m[i] =
//     m[i] ||
//     function() {
//       (m[i].a = m[i].a || []).push(arguments);
//     };
//   (j = ei.createElement(q)), (s = ei.getElementsByTagName(q)[0]);
//   j.async = true;
//   j.charset = "UTF-8";
//   j.src = "https://static.meiqia.com/dist/meiqia.js";
//   s.parentNode.insertBefore(j, s);
// })(window, document, "script", "_MEIQIA");
// _MEIQIA("entId", "f80312ab5492050ffa5074ae58178732");
// _MEIQIA("withoutBtn");
// //如果需要英文版，可用如下配置
// _MEIQIA("language", "en");
// _MEIQIA("init");

export default {
  name: 'Home',
  components: {
    AboutUs,
    News,
    Activities,
    Publication,
    Organization,
    Teams,
    InfoCount,
    Links,
    QuickLinks,
    CooperativeUnit,
    Gallery
    // ComFooter
  },
  data() {
    return {
      form: {
        title: '',
        adviseContent: ''
      },
      leftFloat: true,
      rightFloat: true,
      centerDialogVisible: false,
      userObj: {}, //用户对象
      Index: 0,
      // 顶部轮播
      imgList: [],
      // aboutOnece文章
      aboutOnece: [],
      filePreview: `${window._CONFIG['filePreview']}?fileId=`,
      menuList: [
        {
          title: 'about',
          submenu: [
            {
              title: 'General',
              type: '1'
            },
            {
              title: 'History',
              type: '2'
            }
          ]
        }
      ]
    };
  },
  computed: {
    activeIndex() {
      return this.$refs.carousel.activeIndex;
    }
  },
  watch: {
    // 监听路由发生改变
    $route: {
      immediate: true,
      handler(newVal) {
        console.log('newVal', newVal.query.name);
        this.activeName = newVal.query.name;
        // if(newVal.query.q) this.requestData()
      }
    }
  },
  /*在模板渲染成html前调用，即通常初始化某些属性值，然后再渲染成视图*/
  created() {
    this.getInfo();
    this.getHeaderImg();
    document.querySelectorAll('.carousel-caption > *').forEach(el => {
      el.style.opacity = 0;
    });
    if (localStorage.getItem('pro__Login_Userinfo')) {
      this.userObj = JSON.parse(
        localStorage.getItem('pro__Login_Userinfo')
      ).value;
    }
  },
  /*在模板渲染成html后调用，在初始化界面完成后，再对html的dom节点进行一些需要的操作*/
  mounted() {
    this.$nextTick(function () {
      this.carouselChange(this.Index);
      // this.initIsotope();
      header();
      // this.initSmoothScroll();
    });
  },

  methods: {
    routetolink(v) {
      console.log(`routetolink`, v.address_link);
      if (v.address_link.startsWith('http')) {
        window.location.href = v.address_link;
        return;
      }
      let query = {};
      // query.code = code;
      // return
      this.$router.push({
        path: `/detail?${v.address_link}`,
        query: query
      });
    },
    toMenu(val1, val2, id) {
      var newStr = val1.split(' ');
      for (var i = 0; i < newStr.length; i++) {
        newStr[i] =
          newStr[i].slice(0, 1).toUpperCase() +
          newStr[i].slice(1).toLowerCase();
      }
      let val = newStr.join(' ');
      console.log(`home`, val);
      localStorage.setItem(`pro__fromName`, val);
      localStorage.setItem(`pro__to`, val2);
      localStorage.setItem(`pro__pid`, id);
    },
    getInfo() {
      let url = `${window._CONFIG['domianURL']}xmu/index/menu`;
      // let token = JSON.parse(localStorage.getItem("pro__Access-Token")).value;
      this.$axios({
        method: 'get',
        url: url,
        headers: {}
        // data: sendobj,
      }).then(res => {
        this.menuList = res.data.result;
      });
    },
    getHeaderImg() {
      let ucode = 'c9554dbef8074a6e844fe3119f240812';
      let url = `${window._CONFIG['domianURL']}xmu/index/getData/${ucode}?column=id&order=desc&pageNo=1&pageSize=999&superQueryMatchType=and`;
      this.$axios({
        method: 'get',
        url: url
      }).then(res => {
        let data = res.data.result.records;
        this.imgList = data;
      });
    },

    closeFloat(type) {
      console.log('type', type);
      if (type == '1') {
        this.leftFloat = false;
      } else {
        this.rightFloat = false;
      }
    },
    handleSelect() {},
    signOut() {
      window.localStorage.clear();
      window.location.reload();
    },
    sendLY() {
      let sendobj = this.form;
      let token = JSON.parse(localStorage.getItem('pro__Access-Token')).value;
      this.$axios({
        method: 'post',
        url: 'https://mini.kingboya.com:10540/xm/msg/leave',
        headers: {
          // 设置请求头
          'X-Access-Token': token,
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: sendobj
      }).then(res => {
        // 成功后的回调函数
        if (res.data.code == 200) {
          this.$message({
            message: 'success',
            type: 'success'
          });
          this.centerDialogVisible = false;
        } else {
          this.$message.error('error');
        }
      });
    },
    carouselChange: function (activeIndex) {
      const captionsEl = document.querySelectorAll('.carousel-caption');
    },
    initSmoothScroll() {
      const scroll = new SmoothScroll(
        'nav a[href*="#"], .scroll-to-top a[href*="#"]',
        {
          /*是否有固定导航*/
          header: 'header',
          /*当滚动到区域时的偏移量*/
          offset: 80
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
@import '../assets/style/style.css';

.menu_title {
  color: #000;
  font-family: 'pala';
}
header nav a {
  margin: 0 10px 0 24px;
}

.act_bg {
  background-image: url(/static/img/activites-bg.251a2b8d.png);
  background-size: 100% 100%;
  margin-top: 475px;
  width: 100wh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

header {
  box-shadow: 0px 2px 20px 0px rgba(36, 36, 36, 0.2);
  width: 100vw;
  height: 66px;
  display: flex;
  position: relative;
  z-index: 999;
  align-items: center;
  justify-content: flex-end;
  position: fixed;
  background-color: #fff;
}

/deep/ .el-carousel__arrow {
  height: 50px;
  width: 50px;
  transition: 0.3s;
  border-radius: 50%;
  background-color: rgb(31 45 61 / 80%);
  color: #fff;
}

/deep/ .el-carousel__arrow--left {
  left: 16px;
}

/deep/ .el-carousel__arrow--right {
  right: 36px;
}

.logo {
  font-size: 27px;
  font-weight: 600;
  font-family: sans-serif;
  color: var(--text-color-lightest);
  position: absolute;
  left: 25px;
}

.carousel {
  height: 500px;
}

/deep/.el-carousel__container {
  height: 400px;
}

@media screen and (max-width: 2400px) {
  .carousel {
    height: 500px;
  }

  /deep/.el-carousel__container {
    // height: 500px;
  }

  .act_bg {
    background-image: url(/static/img/activites-bg.251a2b8d.png);
    background-size: 100% 100%;
    margin-top: 485px;
    width: 100wh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logo {
    font-size: 27px;
    font-weight: 600;
    font-family: sans-serif;
    color: var(--text-color-lightest);
    position: absolute;
    left: 30px;
  }
}

@media screen and (min-width: 1500px) {
  .carousel {
    height: 300px;
  }
}

@media screen and (min-width: 750px) {
  .carousel {
    height: 400px;
  }

  .logo {
    font-size: 27px;
    font-weight: 600;
    font-family: sans-serif;
    color: var(--text-color-lightest);
    position: absolute;
    left: 10px;
  }

  .act_bg {
    background-image: url(/static/img/activites-bg.251a2b8d.png);
    background-size: 100% 100%;
    margin-top: 375px;
    width: 100wh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.el-carousel__container {
    // height: 500px;
  }
}

.carousel_slide img {
  width: 100%;
  height: 100%;
  /* height: calc(100vh - 66px); */
  -o-object-fit: cover;
  /* object-fit: cover; */
  object-fit: cover;
}

.fl_close {
  position: absolute;
  right: 5px;
  // background-color: #000;
  width: 10px;
  height: 10px;
  z-index: 101000;
  top: 5px;
}

.fl_close2 {
  position: absolute;
  right: -40px;
  // background-color: #000;
  width: 10px;
  height: 10px;
  z-index: 101000;
  top: 7px;
}

.float {
  background-size: 100% 100%;
  left: 10px;
  width: 150px;
  z-index: 999;
  position: absolute;
  animation: mymove 45s infinite;
  -webkit-animation: mymove 45s infinite;
  /* Safari and Chrome */
}

.float:hover {
  animation-play-state: paused;
}

.float2:hover {
  animation-play-state: paused;
}

.float2 {
  width: 150px;
  z-index: 999;
  position: absolute;
  right: 75px;
  animation: mymove 25s infinite;
  -webkit-animation: mymove 25s infinite;
  /* Safari and Chrome */
}

@keyframes mymove {
  //     from {top:70px;}
  // to {top:calc(100vh - 300px);}
  50% {
    transform: translateY(calc(100vh - 100px));
  }
}

@-webkit-keyframes mymove

  /* Safari and Chrome */ {
  50% {
    transform: translateY(calc(100vh));
  }
}

.menu-a {
  text-decoration: none;
  color: #606266;
}

.menuList {
  position: absolute;
  right: 250px;
  top: 0;
}

.sign_style {
  font-family: 'pala';
  color: #000;
  cursor: pointer;
  margin: 0 15px;
  font-size: 16px;
}

/deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #000;
  font-family: 'pala';
}

/deep/.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #000;
  font-family: 'pala';
}

/deep/.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 0px solid #409eff;
}

/deep/.el-menu.el-menu--horizontal {
  border-bottom: 0px solid #409eff;
}

/deep/.el-carousel__indicators--horizontal {
  //   margin-bottom: 170px;
  z-index: 55;
}

/deep/.el-carousel__button {
  height: 5px;
  width: 42px;
}

/deep/.el-carousel__item {
  // width: 900px;
}

/deep/.newsDiv .el-carousel__item--card:not(.is-active) {
  opacity: 0.2;
}

/deep/.newsDiv .is-active .el-image__inner {
  max-width: 960px;
}

/deep/.newsDiv .is-active {
  transform: translateX(310px) scale(1);
}

/deep/.newsDiv .el-carousel__item--card {
  width: 66%;
}

.link-box {
  display: none;
}

.link-btn {
  width: 62px;
  height: 102px;
  font-size: 12px;
  border-radius: 4px;
  color: white;
  position: fixed;
  text-align: center;
  padding: 5px 3px 0px;
  right: 0px;
  bottom: 380px;
  z-index: 999;
}

footer {
  background: url('../assets/images/footer-bg.png');
  padding-bottom: 0;
  margin-top: 0px;
}

.menu-items li a,
.contact-us {
  font-size: 18px;
  color: #1e1e1e !important;
}

.menu-title {
  font-size: 30px;
  color: #003a7e;
}

.fenge {
  width: 194px !important;
}

.footer-list {
  margin: 0;

  li {
    list-style-type: none;
    text-indent: -34px;
    padding-left: 34px;
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 22px;

    a {
      vertical-align: middle;
      color: #1e1e1e;
      text-decoration: none;
    }
  }
}

.footer-list li a:before {
  width: 15px;
  margin-right: 12px;
  background: #a4b9d1;
  display: inline-block;
  vertical-align: middle;
  content: '';
  height: 2px;
  transition: inherit;
}

.address-list {
  margin-bottom: 25px;
  list-style: none;

  li {
    padding: 15px 0;
    font-size: 15px;
  }
}

.footer-Links {
  padding: 0 34px;
}

@media screen and (min-width: 576px) {
  .display-sm-29 {
    font-size: 1rem;
  }
}

@media screen and (max-width: 768px) {
  .footer-Links {
    padding: 0;
  }
}

.w-85 {
  width: 82%;
}

.vertical-align-top {
  vertical-align: top;
}

.d-inline-block {
  display: inline-block !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.copyright {
  display: grid;
  justify-items: center;
  width: 100%;
  max-width: none;
  margin: auto;
  padding: 0;
  color: #ffffff;
  background: #003a7e;
  height: 53px;

  div {
    max-width: 1180px;
    margin: auto;
  }
}

.el-icon-caret-top {
  color: #003a7e;
}

.el-dropdown-link {
  vertical-align: middle;
  cursor: pointer;
  display: flex;
  color: #000;
  align-items: center;

  .imgicont {
    margin-left: 10px;
    vertical-align: middle;
    width: 14px;
    height: 13px;
  }
}

.fgx {
  height: 40px;
  width: 1px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 30px;
  margin-right: 10px;
}

.nav1 {
  padding-right: 60px;
  align-items: center;
}

.modalbottom {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: relative;

  .spanstyle {
    color: rgb(64, 158, 255);
    position: absolute;
    left: 10%;
    top: 0;
  }
}

.leftF {
  position: absolute;
  width: 495px;
  /* height: 832px; */
  top: 2310px;
  z-index: -1;
  height: 1519px;
}

.rightF {
  position: absolute;
  width: 194px;
  top: 1925px;
  z-index: -1;
  right: 0;
  height: 1119px;
}

.yuan {
  position: absolute;
  width: 500px;
  top: 670px;
  z-index: -1;
  right: 0;
}
</style>
